import $ from "jquery";
import {useEffect, useState} from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "../../styles/css/admin-style.css"
import {userService} from "../../services/userService";
import eventEmitter from "../../shared/eventEmitter";
import FormControl from "../../shared/components/FormControl";
import {EventEmitterTypes} from "../../shared/eventEmitterEnum";

interface NewSuperAdminModalProps {
    show: boolean;
    toggle: () => void;
}

const NewSuperAdminModal: React.FC<NewSuperAdminModalProps> = ({ show, toggle}) => {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [isActive, setIsActive] = useState(true);
    const [showErrors, setShowErrors] = useState(false);

    const handleSave = async () => {
        if (!firstName || !lastName || !email) {
            setShowErrors(true);
            return;
        }
        Promise.resolve(
            userService.createUser(firstName, lastName, email)
        ).then(postRes => {
            if(postRes === undefined)
                return;
            eventEmitter.emit(EventEmitterTypes.REFRESH_USERS)
            toggle();
            return postRes;
        });
    };

    return (
        <Modal show={show} onHide={toggle}>
            <Modal.Header closeButton>
                <h5 className="modal-title" id="profileModalTitle">New Admin</h5>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <div className="row gx-3">
                        <Form.Group controlId="userFirstName" className="col-md-6 mb-3">
                            <FormControl
                                showErrors={showErrors}
                                type="text"
                                label="First Name"
                                placeholder="First Name"
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                required
                            />
                        </Form.Group>
                        <Form.Group controlId="userLastName" className="col-md-6 mb-3">
                            <FormControl
                                label="Last Name"
                                showErrors={showErrors}
                                type="text"
                                placeholder="Last Name"
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                                required
                            />
                        </Form.Group>
                    </div>
                    <div className="row gx-3">
                        <Form.Group controlId="userEmail" className="mb-3">
                            <FormControl
                                type="email"
                                label={"Email Address"}
                                placeholder="Email Address"
                                value={email}
                                showErrors={showErrors}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </Form.Group>
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button className="btn btn-primary text-strong text-uppercase m-100" onClick={handleSave}>
                    Create
                </Button>
                <Button className="btn btn-cancel text-strong text-uppercase m-100" onClick={toggle}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
export default NewSuperAdminModal;


